import * as yup from 'yup';
import phoneRegExp from 'Utils/phoneRegex';
import { featureFlagsSchema } from '../featureFlags';

yup.setLocale({
  mixed: {
    notType: 'The ${path} is obligatory',
    required: 'The field ${path} is obligatory',
    oneOf: 'The field ${path} must have one of the following values: ${values}',
  },
});

// const FILE_SIZE = 1024 * 10024;
const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png', 'jpeg', 'jpg', 'png'];

const optionalRequiredSchema = yup.object().shape({
  primaryColor: yup.string().required('Color string required'),
  secondaryColor: yup.string().required('Color string required'),
});

const TENANT_FORM_SCHEMA = yup.object().shape(
  {
    identifier: yup.string().required('Must be a unique string'),
    pipelineId: yup.number().required('Must be a valid number'),
    branch: yup.string().required('Please provide a valid branch name.').oneOf(['dev6', 'master']),
    name: yup.string().required('Please provide a valid name for your TenantCreate.'),
    webAppUrl: yup.string().url().required('Please provide a valid website url.'),
    selectionAlgorithmNotebookUrl: yup.string().url().required('Please provide a valid website url.'),
    translationProvider: yup.string().required('Please select a translation provider.'),
    googleAnalyticsId: yup.string().optional(),
    homePageConfiguration: yup.object().shape({
      branding: yup.object({
        brandingType: yup.string().required('Please select a brand option.'),
        details: yup.object().when(['brandingType'], (pageConfig, innerSchema) => {
          return pageConfig === 'tenant' ? innerSchema.concat(optionalRequiredSchema) : undefined;
        }),
      }),
      siteName: yup.string().required('A site name is required.'),
      fontFamilyName: yup.string().required('A font style is required.'),
      programLongName: yup.string().required('A site name in long form is required.'),
      programShortName: yup.string().required('A site name in short form is required'),
      signInMessage: yup.string().required('A Message is required.'),
    }),
    readerConfiguration: yup.object().shape({
      maxReadsByReader: yup.number().required(),
      requiredReads: yup.number().required(),
      diverseEthnicity: yup.bool().required(),
    }),
    featuresConfiguration: featureFlagsSchema(yup),
    donationPageConfiguration: yup.object().shape({
      isCtaVisible: yup.bool().required(),
    }),
    fundsDisbursement: yup.string().required(),
    legalConfiguration: yup.object().shape({
      copyrightLanguage: yup.string().required(),
      // "privacyPolicy": yup.string().required(),
    }),
    bannerConfiguration: yup.object().shape({
      isBannerEnabled: yup.bool().required(),
      title: yup.string(),
      description: yup.string(),
    }),
    codeFlags: yup
      .array()
      .of(
        yup.object().shape({
          key: yup.string().trim().required('Flag name is required'),
          type: yup.string().oneOf(['boolean', 'string']),
          boolValue: yup.bool(),
          stringValue: yup.string(),
        })
      )
      .test('unique-keys', 'Flag names must be unique', function (rows = []) {
        const seen = new Map();
        for (let i = 0; i < (rows || []).length; i++) {
          const key = (rows[i]?.key || '').trim();
          if (key && seen.has(key)) {
            return this.createError({ path: `${this.path}[${i}].key`, message: 'Duplicate flag name' });
          }
          seen.set(key, i);
        }
        return true;
      }),
    // "databaseConfiguration": yup.object().shape({
    //     "hostName": yup.string().required('A site name is required.'),
    //     "databaseName": yup.string().required("A valid database name is required."),
    //     "username": yup.string().required("Please provide a valid user name."),
    //     "password": yup.string().required("Please provide a valid password.")
    // }),
    // "sendGridConfiguration": yup.object().shape({
    //     "apiKey": yup.string().required("A valid SendGrid apiKey is required."),
    //     "senderEmail": yup.string().email("Please enter a valid email.").required("A sender email is required."),
    //     "templates": yup.array().of(
    //         yup.object().shape({
    //             key: yup.string().required(),
    //             templateId: yup.string().required()
    //         })
    //     )
    // }),
    // "twilioConfiguration": yup.object().shape({
    //     "authToken": yup.string().required('A Twilio Auth Token is required'),
    //     "accountSid": yup.string().required('Please enter a valid account sid.'),
    //     "phoneNumber": yup.string().matches(phoneRegExp, "Please enter a valid phone number").required('Please enter a phone number'),
    // }),
  },
  ['homePageConfiguration']
);

export default TENANT_FORM_SCHEMA;
